export default __webpack_public_path__ + "static/media/dice-roll.c755adaf.gif";